module.exports = __webpack_public_path__ + "img/centro_de_control.29f41997.jpg";